import alwaysNull from './alwaysNull';
/**
 * Alias for `alwaysNull`
 *
 * @func
 * @category Function
 *
 * @sig a -> Object
 *
 * @example
 *
 *        R_.noop() // null
 *
 */

var noop = alwaysNull;
export default noop;